import TotalSentMail from "../../../assets/icons/TotalSentmailIcon.svg";
import OpenedMail from "../../../assets/icons/OpenedMailIcon.svg";
import ClickedMail from "../../../assets/icons/ClickedMail.svg";
import SuccessRate from "../../../assets/icons/SuccessRateIcon.svg";

const stats = [
  { title: "Total sent Mails", value: "2000", icon: TotalSentMail },
  { title: "Opened Mails", value: "80%", icon: OpenedMail },
  { title: "Clicked Mails", value: "60%", icon: ClickedMail },
  { title: "Success Rate", value: "30%", icon: SuccessRate },
];

const MailStatCard = () => {
  return (
    <div
      className="
        mt-4
        rounded-xl
        min-h-[120px] mb-5
        bg-white dark:bg-slate-800
        shadow
        border border-transparent
        dark:border-slate-700
      "
    >
      <div
        className="
          grid
          grid-cols-1
          sm:grid-cols-2
          md:grid-cols-4
          text-center
          py-8
          px-2
          gap-y-[15px]
        "
      >
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className={`
              flex items-center justify-center
              px-2
              ${
                idx < stats.length - 1
                  ? "md:border-r border-slate-300/40 dark:border-slate-600/50"
                  : ""
              }
            `}
          >
            {/* Icon */}
            <img
              src={stat.icon}
              alt={stat.title}
              className="w-10 h-10 mr-3 object-contain"
            />

            {/* Text */}
            <div className="text-left">
              <div
                className="
                  text-base
                  font-medium
                  text-slate-700 dark:text-slate-300
                  whitespace-nowrap
                "
              >
                {stat.title}
              </div>

              <div
                className="
                  text-[32px]
                  font-bold
                  leading-tight
                  text-slate-900 dark:text-white
                "
              >
                {stat.value}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MailStatCard;